import {logger} from 'yougile-util'

/**
 * Tracks mouse position on page.
 */
export class Mouse {
  public dragList = 0

  public dragItem: unknown = undefined
  public dragData: unknown = undefined
  public dragItemRestrict = ''
  public dropHandler?: () => void
  public dragItemPos: {
    width: number
    height: number
    diffX: number
    diffY: number
  } = {diffX: 0, diffY: 0, height: 0, width: 0}
  public x = 0
  public y = 0
  public onMoveHandlers: Set<(event: MouseEvent) => void> = new Set()
  public onDownHandlers: Set<(event: MouseEvent) => void> = new Set()

  // return value indicates if some drag list accepted the drop
  public onUpHandlers: Set<() => boolean> = new Set()
  public pressed = false

  constructor() {
    document.addEventListener('mousemove', (e: MouseEvent) => this.onMove(e))
    document.addEventListener('mousedown', (e: MouseEvent) => this.onDown(e))
  }

  public onMove: (event: MouseEvent) => void = (event: MouseEvent): void => {
    this.x = event.clientX
    this.y = event.clientY
    if (this.pressed && !!this.dragItem) {
      requestAnimationFrame(() =>
        this.onMoveHandlers.forEach(f => f(undefined))
      )
    }
  }

  public pseudoDown: () => void = (): void => {
    this.onDownHandlers.forEach(f => f(undefined))
  }

  public onDown: (e: MouseEvent) => void = (event: MouseEvent): void => {
    this.x = event.pageX
    this.y = event.pageY
    this.onDownHandlers.forEach((f: (e: MouseEvent) => void) => f(event))
    this.pressed = true
  }

  public onUp = (notAcceptedCb: () => void) => {
    this.pressed = false
    for (const hndl of [...this.onUpHandlers]) {
      try {
        if (hndl()) {
          return // only one drag list can accept a drop
        }
      } catch (e) {
        logger.warn(e)
      }
    }
    notAcceptedCb()
  }

  public drop = (cb: () => void) => {
    this.dropHandler = cb
    this.onUp(cb)
  }

  public reset(): void {
    this.dropHandler = undefined
    this.dragItem = undefined
    this.dragData = undefined
    this.dragItemRestrict = ''
    this.dragItemPos = {diffX: 0, diffY: 0, height: 0, width: 0}
  }
}

export const mouse = new Mouse()
